/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, { useState, useEffect } from 'react';
import {useParams} from "react-router-dom";
import PageBox from "../../layouts/pageBox";
import AccordionParts from "../../elements/AccordionParts";
import PageHeader from "../../layouts/PageHeader";
import Loader from "../../elements/loader";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import SEO from "../../components/SEO";


const PartsByCategory = () => {

    let params = useParams();
    const queryParameters = new URLSearchParams(window.location.search);
    const _bodytype = queryParameters.get("bodytype");
    const _bodytypeTitle = queryParameters.get("bodytypeTitle");
    const { t, i18n } = useTranslation();

    const [parts, setParts] = useState({isLoading: true, data: [], error: false});
    const [latestAds, setLatestAds] = useState([]);
    const [selectedTitle, setSelectedTitle] = useState({
        make: "",
        model: "",
    });

    const [searchValue, setSearchValue] = useState("");
    const [allOpen, setAllOpen] = useState(false);

    const axiosJWT = useAxiosJTW();

    const [headerData, setHeaderData] = useState({
        title : '',
        description : '',
        logo: ''
    });

    const data = {
        title: t('parts.listingTitle'),
        subtitle: t('parts.listingSubtitle'),
    };

    const getPartsByModel = (signal) => {
        axiosJWT.post('api/getpartsbymodel', { make: params.make, model: params.model, year: params.year }, {signal}).then( (response) => {
            if(response.status === 200){

                setParts({...parts, data: response.data.part_categories|| [], isLoading: false});
                setLatestAds(response.data.latest_ads.parts || []);
                setSelectedTitle({
                    make: response.data.title,
                    model: response.data.model_name,
                })
                setHeaderData({
                    title : response.data.title,
                    subtitle : null,
                    logo: response.data.logo,
                });
            }
        } ).catch((error) => {
            setParts({...parts, isLoading: true, error: true});
        });

    }
    function updateOpen(data){
        setAllOpen(data);
    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getPartsByModel(signal);

        return () => {controller.abort();}
    }, [params]);

    return (
        <PageBox data={data} latestAds={latestAds}>
            <SEO
                title={t('meta_title.partsCategories', {make: selectedTitle.make, model: selectedTitle.model, bodytype: "", year_range: params.year})}
                description={t('meta_description.partsCategories', {make: selectedTitle.make, model: selectedTitle.model, bodytype: _bodytypeTitle, year_range: params.year})}
            />
            <div className='page-header'>
                <PageHeader data={headerData} onSearch={setSearchValue} value={searchValue} onUpdateSearch={updateOpen}/>
                {parts.isLoading ? (
                    <></>
                ) : (
                    <div>{selectedTitle.make} {selectedTitle.model} {_bodytypeTitle} {params.year}</div>
                )}

            </div>
            <div className='page-body'>
                {parts.isLoading ? (
                    <>
                        <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                        {parts.error &&<div style={{ paddingTop: '30px', textAlign : 'center', color: 'red' }}>{t('parts.reqerror')}</div>}
                    </>
                ) : (
                    parts.data.map((item, index) => {
                        return (
                         <AccordionParts part={item} key={index} search={searchValue} isallOpen={allOpen} link={`/${i18n.language}/parts/listing/${params.make}/${params.model}/slug/${params.year}?bodytype=${_bodytype}&spec=value`}/>
                        );
                    })
                )}
            </div>
        </PageBox>
    );
};

export default PartsByCategory;
